import WFConditionsList from "./WFConditionsList";

export default WFConditionsList;



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WFConditionsList/index.js